// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"TransferGraphPdf_spinnerContainer__gzPgz","spinner":"TransferGraphPdf_spinner__3cAC6"};